export default __webpack_public_path__ + "static/media/higher_primary_hi_ident_tagline.30a54934.svg";